import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, LogIn } from 'lucide-react';
import { Button } from './ui/button';
import { navLinks } from '../mock';
import BrandLogo from './BrandLogo';
import { useAuth } from '../context/AuthContext';

const Header = ({ onGetStarted, onLogin }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isHome = location.pathname === '/';

  const handleNav = (n) => {
    setOpen(false);
    if (n.type === 'scroll') {
      if (!isHome) {
        navigate('/');
        setTimeout(() => {
          const el = document.querySelector(n.href);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 60);
      } else {
        const el = document.querySelector(n.href);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(n.href);
    }
  };

  const login = () => {
    if (user) return navigate('/dashboard');
    if (onLogin) return onLogin();
    navigate('/auth/login');
  };
  const start = () => {
    if (user && !user.onboarded) return navigate('/onboarding');
    if (user) return navigate('/dashboard');
    if (onGetStarted) return onGetStarted();
    navigate('/auth/signup');
  };

  const activePath = location.pathname;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#2A1810]/90 border-b border-[#4a3221]">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <BrandLogo size="md" />

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((n) => {
            const active = n.type === 'route' ? activePath === n.href : isHome && n.label === 'Home';
            return (
              <button
                key={n.label}
                onClick={() => handleNav(n)}
                className={`relative text-[15px] transition-colors ${
                  active ? 'text-[#F4C430]' : 'text-[#E8DCC8] hover:text-[#F4C430]'
                }`}
              >
                {n.label}
                {active && (
                  <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-[2px] w-6 bg-[#F4C430] rounded-full" />
                )}
              </button>
            );
          })}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            onClick={login}
            className="px-5 py-2.5 rounded-full text-[#F5EDE0] border border-[#5a3d24] hover:border-[#F4C430] hover:text-[#F4C430] transition-colors text-sm font-medium"
          >
            <span className="inline-flex items-center gap-2"><LogIn size={16} /> Log in</span>
          </button>
          <Button
            onClick={start}
            className="rounded-full bg-[#F4C430] hover:bg-[#FFD34E] text-[#2A1810] font-semibold px-6 py-5 h-auto shadow-[0_8px_24px_-8px_rgba(244,196,48,0.55)]"
          >
            Get Started
          </Button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#F5EDE0] p-2.5 -mr-1"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#4a3221] bg-[#2A1810]">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((n) => {
              const active = n.type === 'route' ? activePath === n.href : isHome && n.label === 'Home';
              return (
                <button
                  key={n.label}
                  onClick={() => handleNav(n)}
                  className={`text-left px-3 py-3 rounded-lg ${
                    active ? 'bg-[#3D2817] text-[#F4C430]' : 'text-[#E8DCC8] hover:text-[#F4C430]'
                  }`}
                >
                  {n.label}
                </button>
              );
            })}
            <div className="flex gap-2 pt-3">
              <button
                onClick={login}
                className="flex-1 px-4 py-2.5 rounded-full text-[#F5EDE0] border border-[#5a3d24] text-sm"
              >
                Log in
              </button>
              <Button
                onClick={start}
                className="flex-1 rounded-full bg-[#F4C430] hover:bg-[#FFD34E] text-[#2A1810] font-semibold"
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
